import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";

class Component {
  button = {
    text: 'Cerca',
    cssClass: '',
    hideLoading: true,
  };

  constructor(private $scope: ng.IScope) {}
  
  $onInit() { 
    this.setupListeners();
  }

  private setupListeners() {
    this.$scope.$on('changeActionButtonText', (event, data) => {
      this.button.text = data.text;
    });
  }
}

const component: ng.IComponentOptions = {
  bindings: {
    button: '<',
  },
  template: `
    <button
      type="button"
      class="btn btn-gene new-btn new-btn--full {{$ctrl.button.cssClass}}">
      {{$ctrl.button.text}}
      <span class="fa fa-spin" ng-hide="$ctrl.button.hideLoading"></span>
    </button>
  `,
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.ACTION_BUTTON, component);